import React from 'react';

/**
 * Shared mobile bottom-sheet for picking a page size.
 * Values/options/state stay in the parent (Gallery, Events, etc.).
 */
const PageSizeDialog = ({
  open,
  onClose,
  value,
  onChange,
  options,
  title = 'Items per page',
  optionSuffix = 'items',
}) => {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-end justify-center md:hidden"
      role="dialog"
      aria-modal="true"
      aria-label={title}
    >
      <button
        type="button"
        className="absolute inset-0 w-full h-full bg-black bg-opacity-40 border-0"
        aria-label="Close"
        onClick={onClose}
      />
      <div className="relative w-full max-w-md bg-white rounded-t-3xl shadow-2xl p-5 pb-8">
        <div className="w-12 h-1 bg-gray-300 rounded-full mx-auto mb-4"></div>
        <h3 className="text-base font-bold text-gray-800 text-center mb-4">{title}</h3>
        <div className="space-y-2">
          {options.map((n) => {
            const selected = value === n;
            return (
              <button
                key={n}
                type="button"
                onClick={() => {
                  onChange(n);
                  onClose();
                }}
                className={`w-full flex items-center justify-between px-4 py-3.5 rounded-xl border text-base font-medium transition-colors ${
                  selected
                    ? 'bg-orange-50 border-orange-400 text-orange-600'
                    : 'bg-white border-gray-200 text-gray-700'
                }`}
              >
                <span>{n} {optionSuffix}</span>
                {selected && <i className="fas fa-check text-orange-500"></i>}
              </button>
            );
          })}
        </div>
        <button
          type="button"
          onClick={onClose}
          className="w-full mt-4 px-4 py-3 bg-gray-100 text-gray-700 rounded-xl font-semibold border-0"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default PageSizeDialog;
